import { render, staticRenderFns } from "./IncrementDecrementButton.vue?vue&type=template&id=84367846&scoped=true&"
import script from "./IncrementDecrementButton.vue?vue&type=script&lang=js&"
export * from "./IncrementDecrementButton.vue?vue&type=script&lang=js&"
import style0 from "./IncrementDecrementButton.vue?vue&type=style&index=0&id=84367846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84367846",
  null
  
)

export default component.exports